import { Typography } from '@material-ui/core';
import { getApi } from 'api/axios';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useModificationLogic } from '../hooks/useModificationLogic';

const ActualCommission = ({ modifierId, modifierUriSegment, netAmount, taxRate, shopTier }) => {
  const [printingPrice, setPrintingPrice] = useState();

  const { getUriId } = useModificationLogic();

  const getPrintingPrice = async () => {
    try {
      const res = await (
        await getApi({ baseUrl: window._env_.REACT_APP_QDAK_ORDER_URL })
      ).get(`/admin/delivery-vendor-options/latest`);
      setPrintingPrice(
        res?.data?.find((pP) => pP.modId === getUriId(modifierUriSegment))?.price?.grossAmount
      );
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPrintingPrice();
  }, [modifierId, netAmount, taxRate]);

  const commissionRate = shopTier?.commissionRate || 0;
  const profitWithoutPrinting = Math.floor(netAmount - netAmount * commissionRate);
  const profitWithPrinting =
    printingPrice !== undefined && !isNaN(printingPrice)
      ? Math.floor(netAmount - netAmount * commissionRate - printingPrice)
      : profitWithoutPrinting;

  return (
    <>
      {printingPrice ? (
        <Typography
          style={{
            color:
              profitWithPrinting > 0
                ? 'var(--primary-success)'
                : profitWithPrinting === 0
                ? 'black'
                : 'var(--primary-error)',
            fontWeight: 'bold'
          }}>
          {profitWithPrinting > 0 && '+'} {!isNaN(printingPrice) ? profitWithPrinting : profitWithoutPrinting}
        </Typography>
      ) : (
        <Typography
          style={{
            color:
              profitWithoutPrinting === 0 ? 'black' : 'var(--primary-success)',
            fontWeight: 'bold'
          }}>
          {profitWithoutPrinting === 0 ? '0' : `+${profitWithoutPrinting}`}
        </Typography>
      )}
    </>
  );
};

export default ActualCommission;
